import { useState, useEffect } from 'react';

const useMediaQuery = (query: string) => {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches);

  useEffect(() => {
    const media = window.matchMedia(query);
    const listener = () => setMatches(media.matches);

    media.addEventListener('change', listener);
    window.addEventListener('resize', listener);

    return () => {
      media.removeEventListener('change', listener);
      window.removeEventListener('resize', listener);
    };
  }, [query]);

  return matches;
};

export default useMediaQuery;
